export class ModelBase{
  public id : number;
  public uuid: string;
}



// WEBPACK FOOTER //
// ./src/models/base.ts